import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger,
    Label,
    Radio,
    RadioGroup,
    Spinner,
    Text,
    makeStyles,
    useId
} from "@fluentui/react-components";


import {
    ArrowUpload24Filled,
    ArrowUpload24Regular,
    bundleIcon
} from "@fluentui/react-icons";

import { useContext, useState } from "react";
import { CWClientContext } from "../../App";
const ArrowUpload = bundleIcon(ArrowUpload24Filled, ArrowUpload24Regular);



type FileUploadProp = {
    buttonContent: string;
    dialogTitle: string;

};
const useStyles = makeStyles({
    content: {
        display: "flex",
        flexDirection: "column",
        rowGap: "10px",
    },
});

const FileUpload = (prop: FileUploadProp) => {
    const styles = useStyles();
    const cwClient = useContext(CWClientContext);



    const handleSubmit = (ev: React.FormEvent) => {
        ev.preventDefault();
        setSubmitDisabled(true);
        setSubmitText(<Spinner></Spinner>);
        if (uploadFile !== undefined) {
            cwClient.uploadMaster(uploadType, uploadFile, (ev) => {
                console.log("upload progress", ev);
            }).then((res) => {
                setSubmitDisabled(false);
                setSubmitText(<Text>アップロード</Text>)
            });
        } else {
            console.log("upload file not found", uploadFile);
        }
    };

    const masterId = useId("masterId");
    const uploadTypeId = useId("typeId");
    const radioName = useId("radio");
    const [uploadType, setUploadType] = useState<string>("NEW");
    const [uploadFile, setUploadFile] = useState<File>();
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(true);
    const [submitText, setSubmitText] = useState<React.ReactNode>(<Text>アップロード</Text>);
    return (

        <>
            <Dialog modalType="non-modal">
                <DialogTrigger disableButtonEnhancement>
                    <Button
                        icon={<ArrowUpload ></ArrowUpload>}
                    >{prop.buttonContent}</Button>
                </DialogTrigger>
                <DialogSurface
                    aria-describedby={undefined}
                >
                    <form onSubmit={handleSubmit}>
                        <DialogBody>
                            <DialogTitle>{prop.dialogTitle}</DialogTitle>
                            <DialogContent className={styles.content}>
                                <Label required htmlFor={masterId}>
                                    元帳ファイル
                                </Label>
                                <input type="file"
                                    id={masterId}
                                    onChange={(ev) => {
                                        const file = ev.target.files?.item(0);
                                        if (file) {
                                            setUploadFile(file);
                                            setSubmitDisabled(false);
                                        } else {
                                            console.log("file not found");
                                        }
                                    }} />
                                <Label id={uploadTypeId}></Label>
                                <RadioGroup
                                    defaultValue={uploadType}
                                    value={uploadType}
                                    onChange={(ev, data) => {
                                        setUploadType(data.value);
                                    }}
                                >
                                    <Radio name={radioName} value="ALL" label="全件 - 2時間くらいかかります。" disabled={true} />
                                    <Radio name={radioName} value="NEW" label="追加 - 200件以下程度" />
                                </RadioGroup>
                            </DialogContent>
                            <DialogActions>
                                <DialogTrigger disableButtonEnhancement>
                                    <Button appearance="secondary">閉じる</Button>
                                </DialogTrigger>
                                <Button type="submit" appearance="primary"
                                    disabled={submitDisabled}
                                >
                                    {submitText}
                                </Button>
                            </DialogActions>
                        </DialogBody>
                    </form>
                </DialogSurface>
            </Dialog >
        </>
    );

};

export default FileUpload;